import {apiUrls} from "../../constants/apiUrls";
import apiCall from "../../utils/apiCall";
import {PositionCreate, UpdatePosition} from "../../types/api/authorization/position.types";

export const positionService = {
    getAll: () =>
        apiCall.get(apiUrls.authorization.position.getAll),

    create: (position: PositionCreate) =>
        apiCall.post(apiUrls.authorization.position.create, position),

    update: (position: UpdatePosition) =>
        apiCall.put(apiUrls.authorization.position.update, position)
}